// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "nav.p-order[data-v-204ee1fe]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
